<template>
  <div>
    <DashboardHeader title="Manage Students">
      <SnackBar
        :text="snackbarText"
        :colour="snackbarColor"
        :model="snackbarModel"
      ></SnackBar>
      <v-layout row wrap>
        <v-flex xs12 md3 class="px-4">
          <SelectClassComponent
            class="mt-6 mx-2"
            @selected-class="setSelectedClass"
          ></SelectClassComponent>

          <v-card class=" mt-4" v-if="isAdmin" shaped outlined>
            <v-list-item three-line>
              <v-autocomplete
                @change="getNextSid()"
                v-model="selectedAdd"
                label="Select Panel"
                :items="addOptions"
              ></v-autocomplete>
            </v-list-item>
          </v-card>

          <v-card shaped outlined class="my-4">
            <AddStudentManually
              @student-added="addNewStudentToStudents"
            ></AddStudentManually>
          </v-card>

          <v-card
            class="mx-4 mt-4"
            v-if="
              isAdmin &&
                selectedAdd != null &&
                selectedAdd != 'manual' &&
                selectedAdd != 'buttons'
            "
            shaped
            elevation="12"
            max-width="344"
            outlined
          >
            <v-file-input
              class="mx-4"
              :rules="nameRules"
              v-model="selectedFile"
              label="Select File"
              @change="checkUploadedFile()"
            ></v-file-input>
            <v-row>
              <v-btn
                rounded
                class="my-4 mx-auto"
                :color="getThemeColor"
                @click="uploadStudentsData()"
                dark
              >
                <v-icon left>mdi-upload</v-icon>Upload File
              </v-btn>
            </v-row>
          </v-card>

          <vCardContainer
            title="Actions Pane"
            class="mx-2 mt-4"
            :shaped="true"
            v-if="students.length > 0 && isAdmin && selectedAdd == 'buttons'"
            bgColor="#CFD8DC"
          >
            <template #content>
              <vButtonPanel
                class="ml-2"
                :buttons="buttons"
                @button-clicked="handleButtonOnPanelClicked"
              >
              </vButtonPanel>
            </template>
          </vCardContainer>
        </v-flex>
        <v-flex xs12 md9 class="mt-7" style="margin:0px">
          <v-card>
            <v-row>
              <v-switch
                :disabled="students.length < 1"
                v-model="selectAll"
                label="Select All"
                class="ml-8 mt-4"
                @change="selectAllStudents()"
              ></v-switch>
              <v-spacer></v-spacer>
              <v-text-field
                class="mt-0 mx-6"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                style="display:inline"
              ></v-text-field>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="students"
              :search="search"
              :items-per-page="55"
            >
              <template v-slot:item.selection="{ item }">
                <v-checkbox
                  class="shrink"
                  @change="getSelectionsByDatabaseID(item)"
                  :value="item.id"
                  v-model="selectedStudentsIDs"
                ></v-checkbox>
              </template>
              <template v-slot:item.profile="{ item }">
                <v-icon :color="getThemeColor" @click="viewProfile(item)"
                  >mdi-account-circle</v-icon
                >
                <v-icon color="teal accent-3" v-if="isCarded(item.sid)"
                  >mdi-account-badge-horizontal</v-icon
                >
                <v-icon color="red" v-if="isReportBlocked(item.sid)"
                  >mdi-book-lock</v-icon
                >
              </template>
              <template v-slot:item.sid="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'sid')"
                  v-model="item.sid"
                ></v-text-field>
              </template>
              <template v-slot:item.lname="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'lname')"
                  v-model="item.lname"
                ></v-text-field>
              </template>
              <template v-slot:item.fname="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'fname')"
                  v-model="item.fname"
                ></v-text-field>
              </template>

              <template v-slot:item.fid="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'fid')"
                  v-model="item.fid"
                ></v-text-field>
              </template>
              <template v-slot:item.tel="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'tel')"
                  v-model="item.tel"
                ></v-text-field>
              </template>
              <template v-slot:item.border="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'border')"
                  v-model="item.border"
                ></v-text-field>
              </template>
              <template v-slot:item.dob="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'dob')"
                  v-model="item.dob"
                ></v-text-field>
              </template>
              <template v-slot:item.number_of_days_absent="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'number_of_days_absent')"
                  v-model="item.number_of_days_absent"
                ></v-text-field>
              </template>
              <template v-slot:item.promotion="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'promotion')"
                  v-model="item.promotion"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" width="600" persistent>
        <v-card v-if="applyFee">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >Apply Fee ID to Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Students Selected:
            {{ selectedStudents.length }}</v-card-title
          >
          <v-autocomplete
            label="Select Fee ID to Apply"
            class="mx-10"
            :items="feeIDs"
            v-model="selectedFeeID"
          ></v-autocomplete>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn rounded color="success" dark @click="applyFeeIDNow()"
              >Apply Now</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card v-else-if="promoteStudents">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >Promotions For Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Students Selected:
            {{ selectedStudents.length }}</v-card-title
          >
          <SelectClassComponent
            :label="'Select Class Promoted To'"
            class="my-6 mx-10"
            @selected-class="getClassPromotedTo"
          ></SelectClassComponent>
          <v-text-field
            label="Emis Number"
            class="mx-10"
            v-model="schoolEmis"
          ></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn rounded color="success" dark @click="promoteStudentsNow()"
              >Promote Now</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card v-else-if="academicReport">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >View Report For Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Students Selected:
            {{ selectedStudents.length }}</v-card-title
          >

          <div class="mx-10 mt-4">
            <p>
              Source of Marks:
              {{ reportSource || "Select The Source of The Marks" }}
            </p>
            <v-radio-group v-model="reportSource" mandatory>
              <v-radio
                label="Marks Entered Directly On BitsEMS"
                value="BitsEMS"
              ></v-radio>
              <v-radio
                label="Marks Exported From SASAMS"
                value="SASAMS"
              ></v-radio>
            </v-radio-group>
          </div>

          <v-autocomplete
            label="Select Report Term"
            class="mx-10"
            :items="reportTerms"
            v-model="selectedReportTerm"
          ></v-autocomplete>
          <v-autocomplete
            label="Select Report Year"
            class="mx-10"
            :items="reportYears"
            v-model="reportYear"
          ></v-autocomplete>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              color="success"
              dark
              @click="viewAcademicReportsNow()"
              >View Now</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card v-else-if="captureMarks">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >Enter Marks Or View Schedule</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Students Selected:
            {{ selectedStudents.length }}</v-card-title
          >
          <v-autocomplete
            label="Select Report Term"
            class="mx-10"
            :items="reportTerms"
            v-model="selectedReportTerm"
            @change="setOrGetTerm()"
          ></v-autocomplete>
          <v-autocomplete
            v-if="dsrop != null"
            label="Select Report Year"
            class="mx-10"
            :items="reportYears"
            v-model="reportYear"
            @change="setOrGetTerm()"
          ></v-autocomplete>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn rounded color="success" dark @click="markScheduleNow()"
              >Continue</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card v-else-if="billStudents">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >Bill Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Students Selected:
            {{ selectedStudents.length }}</v-card-title
          >
          <v-text-field
            class="mx-6"
            :label="'Amount in ' + getCurrency"
            :rules="nameRules"
            v-model="edAmount"
          ></v-text-field>
          <v-select
            class="mx-6"
            :rules="nameRules"
            v-model="edDescription"
            item-text="name"
            item-value="id"
            :items="categories"
            label="Description"
          ></v-select>
          <DatePickerWithMenu
            @date-selected="getSelectedDate"
          ></DatePickerWithMenu>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn rounded color="success" dark @click="billStudentsNow()"
              >Bill Now</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card v-else-if="blockReport">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >Block Reports for Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Students Selected:
            {{ selectedStudents.length }}</v-card-title
          >
          <v-autocomplete
            :rules="nameRules"
            label="Select Term"
            class="mx-10"
            :items="terms"
            v-model="selectedTerm"
          ></v-autocomplete>
          <v-textarea
            :rules="nameRules"
            label="Give Reason Or Comment"
            class="mx-10"
            v-model="blockReportReason"
          ></v-textarea>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn rounded color="error" dark @click="blockReportNow()"
              >Block Now</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card v-else-if="viewStatement">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >View Statements for Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Students Selected:
            {{ selectedStudents.length }}</v-card-title
          >

          <v-row class="mx-10">
            <h5>Pick A Date For The Statements</h5>
            <v-date-picker v-model="datePicker"></v-date-picker>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              color="primary"
              dark
              @click="viewStudentsStatements()"
              >View Now</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card v-else-if="bulkSMS">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >Comment on Statements of Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Selected Students:
            {{ selectedStudents.length }}</v-card-title
          >
          <v-select
            label="Applicable Month"
            :items="months"
            class="mx-10"
            v-model="selectedMonthForSTMTComment"
          >
          </v-select>

          <v-textarea
            :rules="nameRules"
            label="Message Body"
            class="mx-10"
            v-model="bulkSMSBody"
          ></v-textarea>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="red" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn rounded color="teal" dark @click="saveSTMTCommentsNow()"
              >Save Comments</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card v-else-if="bulkDelete">
          <v-card-title
            :style="{ 'background-color': getThemeColor, color: 'white' }"
            class="headline lighten-2"
            >Delete Selected Students</v-card-title
          >
          <v-card-title class="mt-6 mx-4"
            >Number of Selected Students:
            {{ selectedStudents.length }}</v-card-title
          >

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" dark @click="closeDialog()"
              >Cancel</v-btn
            >
            <v-btn rounded color="error" dark @click="deleteBulkNow()"
              >Delete Now</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import studentsjs from "@/plugins/students";
import helpers from "@/plugins/helpers";
import DashboardHeader from "@/components/DashboardHeader.vue";
import SelectClassComponent from "@/components/GeneralComponents/SelectClassComponent.vue";
import SnackBar from "@/components/myLibrary/SnackBar.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import XLSX from "xlsx";
import vCardContainer from "@/components/Legos/vCardContainer.vue";
import vButtonPanel from "@/components/Legos/vButtonPanel.vue";
import AddStudentManually from "./AddStudentManually.vue";

export default {
  components: {
    DashboardHeader,
    AddStudentManually,
    SelectClassComponent,
    SnackBar,
    DatePickerWithMenu,
    vCardContainer,
    vButtonPanel,
  },
  computed: {
    hasCredits() {
      return this.messageCredit >= this.selectedStudents.length;
    },
    getSelectedClass() {
      return this.$store.getters.getSelectedClass;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getBulkSMSTokenId() {
      return this.$store.getters.getBulkSMSTokenId;
    },
    getBulkSMSTokenSecret() {
      return this.$store.getters.getBulkSMSTokenSecret;
    },
    getBulkSMSBasicAuth() {
      return this.$store.getters.getBulkSMSBasicAuth;
    },
  },
  mounted() {
    this.schoolEmis = this.getUserSchool.emis;
    this.$store.commit("setLoader", true);
    this.setSelectedClass(this.getSelectedClass);
    this.getCardedStudents();
    this.getReportBlocked();

    axios.getData("/auth/get-fee-ids", this.getAccessToken).then((feeIDs) => {
      this.$store.commit("setLoader", false);
      feeIDs.forEach((fid) => {
        const feeAmount = axios.formatMoney(
          Number(fid.deposit) + Number(fid.monthly) * Number(fid.months)
        );
        this.feeIDs.push({
          text:
            fid.fid + " [ Amount: " + this.getCurrency + " " + feeAmount + " ]",
          value: fid.fid,
        });
      });
    });
  },
  data: () => ({
    selectedStudentsIDs: [],
    cardedStudents: [],
    blockedReportStudents: [],
    studentID: null,
    bulkSMSTokenId: "96C2A187620B41FAB3B31E0804F5EA06-01-2",
    bulkSMSTokenSecret: "mCQEABCuSZvZ106I9AKQR4hDAQjOQ",
    bulkSMSBasicAuth:
      "Authorization: Basic OTZDMkExODc2MjBCNDFGQUIzQjMxRTA4MDRGNUVBMDYtMDEtMjptQ1FFQUJDdVNadloxMDZJOUFLUVI0aERBUWpPUQ==",
    bulkSMSBody: null,
    messageCredit: null,
    selectedDate: new Date().toISOString().substr(0, 10),
    schoolEmis: null,
    classPromotedTo: null,
    datePicker: new Date().toISOString().substr(0, 10),
    reportYear: new Date().getFullYear(),
    reportSource: "BitsEMS",
    reportYears: [
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2,
      new Date().getFullYear() - 3,
      new Date().getFullYear() - 4,
    ],
    dialog: false,
    feeIDs: [],
    selectedReportTerm: null,
    dsc: null,
    dsrop: null,
    reportTerms: [
      { text: "Term 1", value: "Term 1" },
      { text: "Term 2", value: "Term 2" },
      { text: "Term 3", value: "Term 3" },
      { text: "Term 4", value: "Term 4" },
    ],
    buttons: [
      {
        label: "Apply Fee",
        icon: "mdi-account",
        event: "apply-fee",
        color: "#3E2723",
      },
      {
        label: "Statements",
        icon: "mdi-receipt",
        event: "view-statements",
        color: "blue",
      },
      {
        label: "Comments",
        icon: "mdi-comment",
        event: "manage-statements-comments",
        color: "black",
      },
      {
        label: "Export Excel",
        icon: "mdi-office",
        event: "export-to-excel",
        color: "green",
      },

      {
        label: "Bill Students",
        icon: "mdi-cash-plus",
        event: "bill-students",
        color: "purple",
      },
      {
        label: "Block Report",
        icon: "mdi-book-lock",
        event: "block-reports",
        color: "red",
      },
      {
        label: "Marks",
        icon: "mdi-account-multiple-check",
        event: "marks-and-schedule",
        color: "blue-grey darken-4",
      },
      {
        label: "Exam Reports",
        icon: "mdi-book-education",
        event: "exam-reports",
        color: "primary",
      },
      {
        label: "Promotions",
        icon: "mdi-check-decagram",
        event: "promotions",
        color: "warning",
      },
      {
        label: "Delete",
        icon: "mdi-delete",
        event: "delete-selected-students",
        color: "error",
      },
    ],
    applyFee: false,
    categories: [],
    billStudents: false,
    viewStatement: false,
    academicReport: false,
    promoteStudents: false,
    bulkSMS: false,
    bulkDelete: false,
    edDescription: null,
    edAmount: null,
    blockReport: false,
    captureMarks: null,
    selectedFeeID: null,
    blockReportReason: "Contact Admin for Details",
    selectAll: false,
    selectedClass: null,
    selectedTerm: null,
    selectedAdd: "buttons",
    selectedFile: null,
    snackbarText: "",
    file64: null,
    snackbarColor: "",
    snackbarModel: false,
    lname: null,
    fname: null,
    grade: null,
    students: [],
    nameRules: [(v) => !!v || "Field is required"],
    addOptions: [
      { text: "Show Buttons Pane", value: "buttons" },
      { text: "Add Student Manually", value: "manual" },
      { text: "Upload Students from SASAMS", value: "sasams" },
      { text: "Upload Students Bitsems Template", value: "bitsems" },
    ],
    showActionButtons: false,
    search: null,
    selectedStudents: [],
    allSelected: [],
    headers: [
      { value: "selection" },
      { text: "Profile", value: "profile" },
      {
        text: "SID",
        align: "start",
        value: "sid",
      },
      { text: "Surname", value: "lname" },
      { text: "Names", value: "fname" },
      { text: "Current Fee ID", value: "fid" },
      { text: "Parent Cell #", value: "tel" },
      { text: "Boarder ", value: "border" },
      { text: "Date of Birth", value: "dob" },
      { text: "Days Absent", value: "number_of_days_absent" },
      { text: "Progression", value: "promotion" },
    ],
    terms: [
      { text: "Term 1", value: "term1" },
      { text: "Term 2", value: "term2" },
      { text: "Term 3", value: "term3" },
      { text: "Term 4", value: "term4" },
    ],
    selectedMonthForSTMTComment: null,
    months: [
      { text: "January", value: "01" },
      { text: "February", value: "02" },
      { text: "March", value: "03" },
      { text: "April", value: "04" },
      { text: "May", value: "05" },
      { text: "June", value: "06" },
      { text: "July", value: "07" },
      { text: "August", value: "08" },
      { text: "September", value: "09" },
      { text: "October", value: "10" },
      { text: "November", value: "11" },
      { text: "December", value: "12" },
    ],
  }),
  methods: {
    getNextSid() {
      if (this.selectedAdd == "manual") {
        this.$store.commit("setLoader", true);
        axios.getData("/auth/get-next-sid", this.getAccessToken).then((sid) => {
          this.studentID = sid;
          this.$store.commit("setLoader", false);
        });
      }
    },
    handleButtonOnPanelClicked(eventName) {
      if (!this.studentsSelectionIsMade()) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
        switch (eventName) {
          case "delete-selected-students":
            this.openBulkDeleteDialog();
            break;
          case "view-statements":
            this.openViewStatementDialog();
            break;
          case "manage-statements-comments":
            this.openSTMTCommentsDialog();
            break;
          case "export-to-excel":
            this.exportMarksList();
            break;
          case "apply-fee":
            this.openApplyFeeDialog();
            break;
          case "bill-students":
            this.openBillStudentsDialog();
            break;
          case "block-reports":
            this.openBlockReportDialog();
            break;
          case "marks-and-schedule":
            this.openCaptureMarksDialog();
            break;
          case "exam-reports":
            this.openAcademicReportDialog();
            break;
          case "promotions":
            this.openPromoteStudentsDialog();
            break;
        }
      }
    },
    getSelectionsByDatabaseID() {
      const filteredStudents = this.students.filter((student) => {
        return this.selectedStudentsIDs.includes(student.id);
      });

      this.selectedStudents = [];
      if (filteredStudents.length > 0) {
        filteredStudents.forEach((student) => {
          this.selectedStudents.push(student.sid);
        });
      }
    },
    getSelectedDate(selectedDate) {
      this.selectedDate = selectedDate;
    },
    selectAllStudents() {
      if (this.selectAll) {
        this.selectedStudents = [];
        this.selectedStudentsIDs = [];
        this.students.forEach((student) => {
          this.selectedStudents.push(student.sid);
          this.selectedStudentsIDs.push(student.id);
        });
      } else {
        this.selectedStudents = [];
        this.selectedStudentsIDs = [];
      }
    },
    billStudentsNow() {
      const students = this.selectedStudents;
      const amount = this.edAmount;
      const description = this.edDescription;
      const selectedDate = this.selectedDate;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/bill-students-now",
          { students, amount, description, selectedDate },
          this.getAccessToken
        )
        .then((response) => {
          if (response == "success") {
            this.$store.commit("setLoader", false);
            this.closeDialog();
            this.$toast.success("Students Successfully Billed!");
          }
        });
    },
    getClassPromotedTo(selectedClass) {
      this.classPromotedTo = selectedClass;
    },
    setSelectedClass(selectedClass) {
      this.selectedClass = selectedClass;
      this.$store.commit("setSelectedClass", selectedClass);

      if (
        selectedClass != null &&
        this.lname == null &&
        this.fname == null &&
        this.grade == null
      ) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/get-students-for-selected-class",
            { selectedClass },
            this.getAccessToken
          )
          .then((studentsData) => {
            this.$store.commit("setLoader", false);
            this.students = studentsData[0];
            this.closeDialog();
          });
      }
    },
    addNewStudentToStudents(studentsData) {
      this.selectedAdd = null;
      this.students.unshift(studentsData);
      this.selectedStudents = [];
      this.selectedStudentsIDs = [];
    },

    checkUploadedFile() {
      if (this.selectedFile != null && this.selectedFile != undefined) {
        const reader = new FileReader();
        reader.addEventListener("load", (event) => {
          this.file64 = event.target.result;
        });
        reader.readAsDataURL(this.selectedFile);
      }
    },
    uploadStudentsData() {
      const fileArr = this.selectedFile.name.split(".");
      const ext = fileArr[fileArr.length - 1];
      axios
        .postDataWithToken(
          "/auth/import-students",
          { file64: this.file64, template: this.selectedAdd, ext: ext },
          this.getAccessToken
        )
        .then((studentsData) => {
          this.selectedAdd = null;
          this.$toast.success("Students Successfully Added!");
          this.students.unshift(studentsData);
          this.selectedStudents = [];
          this.selectedStudentsIDs = [];
        });
    },
    openApplyFeeDialog() {
      this.dialog = true;
      this.applyFee = true;
    },
    openViewStatementDialog() {
      this.dialog = true;
      this.viewStatement = true;
    },
    studentsSelectionIsMade() {
      if (this.selectedStudents.length < 1) {
        return false;
      } else {
        return true;
      }
    },
    openBulkDeleteDialog() {
      this.dialog = true;
      this.bulkDelete = true;
    },
    openBillStudentsDialog() {
      this.dialog = true;
      this.billStudents = true;
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-income-categories", this.getAccessToken)
        .then((categories) => {
          this.$store.commit("setLoader", false);
          this.categories = categories;
        });
    },
    openBlockReportDialog() {
      this.dialog = true;
      this.blockReport = true;
    },
    openAcademicReportDialog() {
      this.dialog = true;
      this.academicReport = true;
    },
    openCaptureMarksDialog() {
      this.dialog = true;
      this.captureMarks = true;
    },
    openPromoteStudentsDialog() {
      this.dialog = true;
      this.promoteStudents = true;
    },
    openSTMTCommentsDialog() {
      this.dialog = true;
      this.bulkSMS = true;
    },
    closeDialog() {
      this.dialog = false;
      this.applyFee = false;
      this.billStudents = false;
      this.blockReport = false;
      this.selectedStudents = [];
      this.selectedStudentsIDs = [];
      this.edDescription = null;
      this.edAmount = null;
      this.viewStatement = false;
      this.academicReport = false;
      this.promoteStudents = false;
      this.bulkDelete = false;
      this.bulkSMS = false;
      this.captureMarks = false;
    },
    updateField(id, column) {
      const value = event.target.value;
      axios.postDataWithToken(
        "/auth/update-item",
        { table: "students", id, column, value },
        this.getAccessToken
      );
    },
    applyFeeIDNow() {
      const students = this.selectedStudents;
      const fid = this.selectedFeeID;
      const cls = this.selectedClass;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/apply-fee-ids-selection",
          { students, fid, cls },
          this.getAccessToken
        )
        .then((studentsData) => {
          this.$store.commit("setLoader", false);
          this.students = studentsData;
          this.closeDialog();
          this.$toast.success("Fee IDs Successfully Applied!");
        });
    },
    saveSTMTCommentsNow() {
      const bulkSMSBody = this.bulkSMSBody;
      const selectedMonth = this.selectedMonthForSTMTComment;

      if (this.selectedStudents.length > 0 && bulkSMSBody != null) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/save-stmt-comments",
            { bulkSMSBody, selectedMonth, sids: this.selectedStudents },
            this.getAccessToken
          )
          .then((response) => {
            if (response == "success") {
              this.$store.commit("setLoader", false);
              this.$toast.success("Comments saved!");
              this.closeDialog();
              return true;
            }
          });
      } else {
        alert("Message Body Field is Required!");
        event.preventDefault();
      }
    },
    blockReportNow() {
      const reason = this.blockReportReason;
      const term = this.selectedTerm;
      const students = this.selectedStudents;
      if (term != null && reason != "" && students.length > 0) {
        axios
          .postDataWithToken(
            "/auth/block-reports",
            { reason, term, students },
            this.getAccessToken
          )
          .then(() => {
            this.closeDialog();
            this.$toast.success("Selected Reports Successfully Blocked!");
          });
      }
    },
    viewProfile(item) {
      this.$store.commit("setCurrentStudent", item);
      this.$router.push({ name: "student-profile", params: { sid: item.sid } });
    },
    viewStudentsStatements() {
      this.$router.push({
        name: "students-statements",
        params: {
          selectedStudents: this.selectedStudents,
          statementsDate: this.datePicker,
        },
      });
    },
    viewAcademicReportsNow() {
      if (this.reportYear == null && this.selectedReportTerm == null) {
        alert("You Must Select Term And Year, Both Are Required!");
        return false;
      } else {
        axios
          .postDataWithToken(
            "/auth/get-selected-students",
            {
              selectedStudents: this.selectedStudents,
            },
            this.getAccessToken
          )
          .then((selStudents) => {
            this.$router.push({
              name: "academic-reports",
              params: {
                selectedSids: this.selectedStudents,
                selectedStudents: selStudents,
                selectedReportTerm: this.selectedReportTerm,
                selectedYear: this.reportYear,
                reportSource: this.reportSource,
                selectedClass: this.selectedClass,
              },
            });
          });
      }
    },
    setOrGetTerm() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/set-or-get-term-info",
          { term: this.selectedReportTerm, year: this.reportYear },
          this.getAccessToken
        )
        .then((term) => {
          this.dsc = term.term_ends;
          this.dsrop = term.next_term_begins;

          this.$store.commit("setLoader", false);
        });
    },
    markScheduleNow() {
      const params = {
        selectedStudents: this.selectedStudents,
        reportYear: this.reportYear,
        selectedReportTerm: this.selectedReportTerm,
        dsc: this.dsc,
        dsrop: this.dsrop,
        selectedClass: this.selectedClass,
      };
      this.$store.commit("setMarksScheduleParams", params);
      this.$router.push({
        name: "marks-schedule",
      });
    },
    promoteStudentsNow() {
      if (
        this.selectedStudents.length > 0 &&
        this.classPromotedTo != null &&
        this.schoolEmis != null
      ) {
        this.$store.commit("setLoader", true);

        const data = {
          students: this.selectedStudents,
          classPromotedTo: this.classPromotedTo,
          emis: this.schoolEmis,
        };

        axios
          .postDataWithToken(
            "/auth/promote-students",
            data,
            this.getAccessToken
          )
          .then((students) => {
            this.$store.commit("setLoader", false);
            this.students = students;
            this.closeDialog();
            this.$toast.success("Selected Students Successfully Promoted!");
          });
      } else {
        this.$toast.warning("All Fields Are Required!");
        event.preventDefault();
      }
    },
    exportMarksList() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-selected-students",
          { selectedStudents: this.selectedStudents },
          this.getAccessToken
        )
        .then((selectedStudents) => {
          const students = [];
          selectedStudents.forEach((student) => {
            students.push({
              Class: student.class,
              SID: student.sid,
              Surname: student.lname,
              Names: student.fname,
              Cloumn1: "",
              Cloumn2: "",
              Cloumn3: "",
              Cloumn4: "",
              Cloumn5: "",
            });
          });

          const data = XLSX.utils.json_to_sheet(students);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, "data");
          XLSX.writeFile(wb, "BitsEMS_Class_List.xlsx");
          this.$store.commit("setLoader", false);
        });
    },
    exportStudentsData() {
      const data = XLSX.utils.json_to_sheet(this.students);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, "BitsEMS_Class_List.xlsx");
    },
    async deleteBulkNow() {
      this.$store.commit("setLoader", true);
      const response = await helpers.deleteMultipleRows(
        "students",
        this.selectedStudentsIDs
      );
      this.setSelectedClass(this.getSelectedClass);

      if (response == "success") {
        this.$toast.success("Selected Students Successfully Deleted!");
      } else {
        this.$toast.error("Oops, Something went wrong!");
      }
    },
    async getCardedStudents() {
      this.cardedStudents = await studentsjs.getCardedStudents();
    },
    getReportBlocked() {
      axios
        .getData("/auth/get-blocked-reports-all", this.getAccessToken)
        .then((sids) => {
          this.blockedReportStudents = sids;
        });
    },
    isCarded(sid) {
      return this.cardedStudents.includes(sid);
    },
    isReportBlocked(sid) {
      return this.blockedReportStudents.includes(sid);
    },
  },
};
</script>

<style></style>
